var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.peerId && _vm.remoteStream)?_c('Avatar',{key:_vm.peerId,attrs:{"id":_vm.peerId,"media-stream":_vm.remoteStream}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }